import React,{useEffect} from "react";
import Notifications from "../components/Notifications";
import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import * as Actions from '../actions/Actions.js';
import { withRouter } from "react-router";

function NotificationsPage(props){
  useEffect(()=>{
        return(()=>props.actions.last_visit());
  },[])
  let last_visit= new Date(props.last_visit);

  return(
    <div>
      <div style={{display:"flex",marginBottom:20}}>
        <div style={{fontSize:22,fontWeight:500}}>All Notifications:</div>
        <div style={{cursor:"pointer",flex:1,display:"flex",alignItems:"flex-start",fontWeight:"500",fontSize:28,lineHeight:"28px",justifyContent:"flex-end"}} onClick={()=>props.history.goBack()}>x</div>
      </div>
      <Notifications lastVisit={last_visit} onHide={()=>{}} resetCount={props.actions.last_visit} notifications={props.notifications} />
    </div>
  );
}

export default withRouter(connect(state => ({...state.data,...state.persistData}), (dispatch) => ({
  actions: bindActionCreators(Actions, dispatch)
}))(NotificationsPage));
